<!DOCTYPE html>
<html lang="en">
    <head no-update>
        <link rel="icon" type="image/x-icon" href="../../assets/favicon.png">
        <meta name="theme-color" content="#e64980" />
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <meta name="description" content="A personal website showcasing web design, web apps, fun projects and more.">
        <link rel="preconnect" href="https://fonts.googleapis.com">
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
        <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@100;400;900&family=Bitter:ital,wght@0,400;1,400&display=swap" rel="stylesheet">
    </head>
    <body>
        <${input.renderBody}/>
    </body>
</html>